import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "@firebase/firestore";
import { projectFirestoreDB } from "../../firebase/config";
import { Image, Box, Button } from "@chakra-ui/react";
import { useAuth } from "../contexts/AuthContext";
import createNFT from "../algorand/createNFT"; // bara att importera den gör att den kör igenom hela processen, måste få den som en funkjtion

export default function ImagePage() {
  const [memeImg, setMemeImg] = useState();
  const [isLoading, setIsLoading] = useState(true);
  let { imageid } = useParams();
  const { currentUser } = useAuth();

  async function fetchMemeImgData() {
    const docRef = doc(projectFirestoreDB, "memeImages", imageid);
    const docSnap = await getDoc(docRef);
    const memeImgArray = [];

    if (docSnap.exists()) {
      memeImgArray.push({
        createdAt: docSnap.data().createdAt,
        createdBy: docSnap.data().createdBy,
        title: docSnap.data().title,
        url: docSnap.data().url,
        isMinted: docSnap.data().isMinted,
      });
      setMemeImg(memeImgArray[0]);
      setIsLoading(false);
      console.log("Document data: ", docSnap.data());
      console.log("Document data in array: ", memeImgArray);
    } else {
      console.log("No such document, undefined");
    }
  }

  useEffect(() => {
    fetchMemeImgData();
  }, []);

  function IsUserCreator(props) {
    if (currentUser?.uid == props.createdBy && props.isMinted == false) {
      return (
        <Button onClick={() => createNFT(imageid, memeImg.title)}>
          Mint this picture as an NFT
        </Button>
      );
    }
  }

  return (
    <div>
      {isLoading && <p>Loading</p>}
      {!isLoading && (
        <Box
          maxW="xl"
          mx="auto"
          py="5"
          //borderWidth="1px"
          overflow="hidden"
        >
          <Image src={memeImg.url}></Image>
          <Box p="4" borderWidth="1px" display="flex">
            {memeImg.title}
            {IsUserCreator(memeImg)}
          </Box>
        </Box>
      )}
    </div>
  );
}
